import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';

import MainInformation from './main';
import Projects from './projects';

import Reforms from './reforms';

import Documents from './documents';
import Procurements from './procurements';

import Corruption from './corruption';
import CorruptionDetail from './corruption/detail';

import Faq from './faq';
import FaqDetail from './faq/detail';

import Communities from './communities';
import CommunityDetail from './communities/detail';

import ProjectsDetail from './projects/detail';
import ReformsDetail from './reforms/detail';

class InformationService extends Component {
  render() {

    const path = this.props.match.path;

    return(
      <div>
        <Switch>
					<Route exact path={`${path}`} component={MainInformation}/>

					<Route exact path={`${path}/projects`} component={Projects}/>
					<Route exact path={`${path}/projects/:page`} component={Projects}/>
					<Route exact path={`${path}/projects/detail/:id`} component={ProjectsDetail}/>

					<Route exact path={`${path}/reforms`} component={Reforms}/>
					<Route exact path={`${path}/reforms/:page`} component={Reforms}/>
          <Route exact path={`${path}/reforms/detail/:id`} component={ReformsDetail}/>

					<Route exact path={`${path}/documents`} component={Documents}/>
					<Route exact path={`${path}/documents/:page`} component={Documents}/>
					<Route exact path={`${path}/procurements`} component={Procurements}/>
          <Route exact path={`${path}/procurements/:page`} component={Procurements}/>

					<Route exact path={`${path}/corruption`} component={Corruption}/>
					<Route exact path={`${path}/corruption/:page`} component={Corruption}/>
          <Route exact path={`${path}/corruption/detail/:id`} component={CorruptionDetail}/>

					<Route exact path={`${path}/faq`} component={Faq}/>
					<Route exact path={`${path}/faq/:page`} component={Faq}/>
          <Route exact path={`${path}/faq/detail/:id`} component={FaqDetail}/>

					<Route exact path={`${path}/communities`} component={Communities}/>
					<Route exact path={`${path}/communities/detail/:id`} component={CommunityDetail}/>
				</Switch>
      </div>
    )
  }
}

export default InformationService



// WEBPACK FOOTER //
// ./src/system/information-center/index.js